export default "__VITE_ASSET__OCsDAqtq__"